import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Phuongtientable = React.memo(function Phuongtientable(props) {
  const classes = useStyles();
  const { phuongtien } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th_dn}>stt</th>
          <th className={classes.tablebc_th_dn}>Số đăng ký</th>
          <th className={classes.tablebc_th_dn}>Tải trọng</th>
          <th className={classes.tablebc_th_dn}>Sức chứa</th>
          <th className={classes.tablebc_th_dn}>Số phù hiệu</th>
          <th className={classes.tablebc_th_dn}>Phù hiệu</th>
          <th className={classes.tablebc_th_dn}>Ngày cấp</th>
          <th className={classes.tablebc_th_dn}>Ngày hết hạn</th>
          <th className={classes.tablebc_th_dn}>Trạng thái</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {phuongtien.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["stt"]}</td>
              <td className={classes.tablesotan_td}>{row["sodangky"]}</td>
              <td className={classes.tablesotan_td}>{row["taitrong"]}</td>
              <td className={classes.tablesotan_td}>{row["succhua"]}</td>
              <td className={classes.tablesotan_td}>{row["sophuhieu"]}</td>
              <td className={classes.tablesotan_td}>{row["phuhieu"]}</td>
              <td className={classes.tablesotan_td}>{row["ngaycap"]}</td>
              <td className={classes.tablesotan_td}>{row["ngayhethan"]}</td>
              <td className={classes.tablesotan_td}>{row["trangthai"]}</td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table}>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Phuongtientable.propTypes = {
  phuongtien: PropTypes.array,
};
export default Phuongtientable;
